import {OperatorTypeEnum} from "@/model/Workflow";
import type {OperatorNodeType} from "@/view/workflow/components/workflowGraph/types";

export const getOperatorNodeType = (operatorType: OperatorTypeEnum): OperatorNodeType => {
    if (operatorType === OperatorTypeEnum.BRANCH_PYTHON)
        return "branchNode";
    if ([OperatorTypeEnum.LLM, OperatorTypeEnum.LANGCHAIN].includes(operatorType))
        return "llmNode";

    return "generalNode";
}

export function buildOperatorEdgeId(source: string, target: string, branchKey?: string) {
    if (branchKey)
        return `edge-${source}-${target}-${branchKey}`;

    return `edge-${source}-${target}`;
}